
import React from 'react';
import { useBlogPosts } from '@/hooks/useBlogPosts';
import BlogCard from './BlogCard';
import { 
  Pagination, 
  PaginationContent, 
  PaginationItem, 
  PaginationLink, 
  PaginationNext, 
  PaginationPrevious 
} from '@/components/ui/pagination';

const BlogList: React.FC = () => {
  const { data: blogPosts, isLoading, error } = useBlogPosts();

  if (isLoading) {
    return (
      <div className="space-y-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
              <div className="animate-pulse">
                <div className="h-6 bg-gray-200 rounded w-3/4 mb-3"></div>
                <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-2/3 mb-4"></div>
                <div className="h-4 bg-gray-200 rounded w-32"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Error al cargar los artículos del blog.</p>
      </div>
    );
  }

  if (!blogPosts || blogPosts.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">No hay artículos disponibles.</p>
      </div>
    );
  }

  // Filter out featured posts to avoid duplication
  const nonFeaturedPosts = blogPosts.filter(post => !post.featured);

  return (
    <div className="space-y-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {nonFeaturedPosts.map(post => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
      
      {/* Cleaned up pagination */}
      <div className="flex justify-center pt-8">
        <Pagination>
          <PaginationContent className="flex items-center gap-2">
            <PaginationItem>
              <PaginationPrevious 
                href="#" 
                className="text-coolGray hover:text-navy"
              >
                ← Anterior
              </PaginationPrevious>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink 
                href="#" 
                isActive
                className="bg-primary text-white hover:bg-primary/90"
              >
                1
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink 
                href="#"
                className="text-coolGray hover:text-navy hover:bg-gray-50"
              >
                2
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink 
                href="#"
                className="text-coolGray hover:text-navy hover:bg-gray-50"
              >
                3
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <span className="text-coolGray px-2">…</span>
            </PaginationItem>
            <PaginationItem>
              <PaginationNext 
                href="#"
                className="text-coolGray hover:text-navy"
              >
                Siguiente →
              </PaginationNext>
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      </div>
    </div>
  );
};

export default BlogList;
